//
export default [
    'pch_provider',
    'pch_provider_branch_offices',
    'pch_payment_condition',
    'wh_warehouse',
    'g_originator_user.hr_employee',
    'pch_detail_purchase_orders.wh_product',
]
